import Vue from "vue";
import VueRouter from "vue-router";
import { TokenService } from "@/services/storage.service";
import ResetCustomerPass from "@/views/ResetCustomerPassword/ResetPassword.vue";
import Login from "@/views/Login/Login.vue";
import User from "@/views/Users/User.vue";
import ResetPassword from "@/views/Users/ResetPassword.vue";
import DetailUser from "@/views/Users/DetailUser.vue";
import Brand from "@/views/Brands/Brand.vue";
import TermsAndConditions from "@/views/TermsAndConditions/TermsAndConditions.vue";
import News from "@/views/News/News.vue";
import Membership from "@/views/Membership/Membership.vue";
import Privilege from "@/views/Privilege/Privilege.vue";
import PrivilegeCategory from "@/views/PrivilegeCategory/PrivilegeMain.vue";
import RewardCategory from "@/views/RewardCategory/RewardCategory.vue";
import ContactSubjects from "@/views/ContactSubject/ContactSubject.vue";
import BroadcastMessages from "@/views/BroadcastMessage/BroadcastMessage.vue";
import BroadcastMessageConfig from "@/views/BroadcastMessageConfiguration/BroadcastMessageConfig.vue";
import CrmTrigger from "@/views/CrmTrigger/CrmTrigger.vue";
import ProductMaster from "@/views/ProductMaster/ProductMaster.vue";
import ImportProductDisplayName from "@/views/ImportProductDisplayName/ImportProductDisplayName.vue";
import DetailMembership from "@/views/Membership/DetailMembership.vue";
import DetailPrivilege from "@/views/Privilege/DetailPrivilege.vue";
import DetailPrivilegeCategory from "@/views/PrivilegeCategory/PrivilegeCategoryDetail.vue";
import DetailRewardCategory from "@/views/RewardCategory/DetailRewardCategory.vue";
import DeliveryLabel from "@/views/DeliveryLabel/DeliveryLabel.vue";
import DetailNews from "@/views/News/DetailNews.vue";
import DetailBrand from "@/views/Brands/DetailBrand.vue";
import DetailTermsAndConditions from "@/views/TermsAndConditions/DetailTermsAndConditions.vue";
import DetailContactSubjects from "@/views/ContactSubject/DetailContactSubject.vue";
import DetailBroadcastMessages from "@/views/BroadcastMessage/DetailBroadcastMessage.vue";
import DetailCrmTrigger from "@/views/CrmTrigger/DetailCrmTrigger.vue";
import ShiseidoProductCategory from "@/views/ShiseidoProductCategory/ShiseidoProductCategory.vue";
import CPBProductFullDescription from "@/views/CPBProductFullDescription/CPBProductFullDescription.vue";
import DetailProduct from "@/views/ProductMaster/DetailProduct.vue";
import StoreMaster from "@/views/Store/Store.vue";
import DetailStore from "@/views/Store/DetailStore.vue";
import Survey from "@/views/Survey/Survey.vue";
import DetailSurvey from "@/views/Survey/DetailSurvey.vue";
import PosCustomer from "@/views/POSCustomer/PosCustomer.vue";
import DetailPosCustomer from "@/views/POSCustomer/DetailPosCustomer.vue";
import CustomerProfile from "@/views/CustomerProfile/CustomerProfile.vue";
import DetailCustomerProfile from "@/views/CustomerProfile/DetailCustomerProfile.vue";
import CrmMetrics from "@/views/Reports/CRMMetrics/CRMMetrics.vue";
import DetailCrmMetrics from "@/views/Reports/CRMMetrics/DetailCrmMetrics.vue";
import CustomerMetrics from "@/views/Reports/CustomerMetrics/CustomerMetrics.vue";
import DetailCustomerMetrics from "@/views/Reports/CustomerMetrics/DetailCustomerMetrics.vue";
import RetentionProduct from "@/views/Reports/RetentionProduct.vue";
import CustomerListByPurchasedProduct from "@/views/Reports/CustomerListByPurchasedProduct";
import SurveyReport from "@/views/Reports/Survey/Survey.vue";
import AuditLogs from "@/views/ActivityLogs/ActivityLogs.vue";
import MobileAppSupportedVersion from "@/views/MobileAppSupportedVersion/MobileAppSupportedVersion.vue";
import SystemStatus from "@/views/SystemStatus/ListSystemStatus.vue";
import AppLogin from "@/components/Layouts/AppLogin/AppLogin.vue";
import AppLayout from "@/components/Layouts/AppLayout/AppLayout.vue";
import EmptyLayout from "@/components/Layouts/EmptyLayout/EmptyLayout.vue";
import Service from "@/views/Service/Service.vue";
import DetailServiceMaster from "@/views/Service/DetailServiceMaster.vue";
import CounterService from "@/views/Store/CounterService/CounterService.vue";
import DetailResourceMaster from "@/views/Store/CounterService/DetailResourceMaster.vue";
import BookingCalendar from "@/views/Booking/Calendar.vue";
import Booking from "@/views/Booking/Booking.vue";
import DetailBooking from "@/views/Booking/DetailBooking.vue";
import TopSpenderCampaign from "@/views/TopSpenderCampaign/TopSpenderCampaign.vue";
import DetailTopSpenderCampaign from "@/views/TopSpenderCampaign/DetailTopSpenderCampaign.vue";
import ReferralCampaign from "@/views/ReferralCampaign/ReferralCampaign.vue";
import DetailReferralCampaign from "@/views/ReferralCampaign/DetailReferralCampaign.vue";
import PublicHolidays from "@/views/PublicHolidays/PublicHolidays.vue";
import Shift from "@/views/Shift/Shift.vue";
import UserRevocations from "@/views/OfficialWebsite/UserRevocations.vue";
import UserRevocationDetail from "@/views/OfficialWebsite/UserRevocationDetail.vue";
import OfficialWebsite from "@/views/OfficialWebsite/OfficialWebsite.vue";
import AgeGroup from "@/views/Reports/AgeGroup/AgeGroup.vue";
import DetailAgeGroupReport from "@/views/Reports/AgeGroup/DetailAgeGroupReport.vue";
import TargetEmail from "@/views/TargetEmail/TargetEmail.vue";

Vue.use(VueRouter);

const EmptyParentComponent = {
  template: "<router-view></router-view>",
};

const routes = [
  {
    path: "/",
    redirect: { name: "Login" },
  },
  {
    path: "*",
    redirect: { name: "Exception401" },
  },
  {
    path: "/Exception",
    component: EmptyParentComponent,
    meta: {
      public: true, // Allow access to even if not logged in
    },

    children: [
      {
        name: "Exception401",
        path: "401",
        component: () => import("../views/Exceptions/Exception401.vue"),
      },
    ],
  },
  {
    path: "/",
    component: AppLayout,
    children: [
      {
        path: "/main",
        name: "ResetCustomerPass",
        component: ResetCustomerPass,
        meta: {
          title: "Reset Password",
          requiresAuth: true,
          auth: ["ROLE_BC", "ROLE_SALES_SUPERVISOR"],
        },
      },
      {
        path: "/users",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "Users",
            component: User,
            meta: {
              title: "Users",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
          {
            path: "detailuser",
            name: "DetailUser",
            component: DetailUser,
            meta: {
              title: "User Detail",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
        ],
      },
      {
        path: "/brand",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "Brand",
            component: Brand,
            meta: {
              title: "Brand",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
          {
            path: "detailbrand",
            name: "DetailBrand",
            component: DetailBrand,
            meta: {
              title: "Brand Detail",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
        ],
      },
      {
        path: "/termsAndConditions",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "TermsAndConditions",
            component: TermsAndConditions,
            meta: {
              title: "Terms and Conditions",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
          {
            path: "detailTermsAndConditions",
            name: "DetailTermsAndConditions",
            component: DetailTermsAndConditions,
            meta: {
              title: "Terms and Conditions Detail",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
        ],
      },
      {
        path: "/news",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "News",
            component: News,
            meta: {
              title: "News",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
          {
            path: "detailnews",
            name: "DetailNews",
            component: DetailNews,
            meta: {
              title: "News Detail",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
        ],
      },
      {
        path: "/member",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "Membership",
            component: Membership,
            meta: {
              title: "Membership",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
          {
            path: "detailmembership",
            name: "DetailMembership",
            component: DetailMembership,
            meta: {
              title: "Membership Detail",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
        ],
      },
      {
        path: "/privilege",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "Privilege",
            component: Privilege,
            meta: {
              title: "Privileges",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
          {
            path: "detailprivilege",
            name: "DetailPrivilege",
            component: DetailPrivilege,
            meta: {
              title: "Privilege Detail",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
        ],
      },
      {
        path: "/privilegeCategory",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "PrivilegeCategory",
            component: PrivilegeCategory,
            meta: {
              title: "Privileges Category",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
          {
            path: "detailprivilegecategory",
            name: "DetailPrivilegeCategory",
            component: DetailPrivilegeCategory,
            meta: {
              title: "Privilege Category Detail",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
        ],
      },
      {
        path: "/rewardCategory",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "RewardCategory",
            component: RewardCategory,
            meta: {
              title: "Rewards Category",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
          {
            path: "detailRewardCategory",
            name: "DetailRewardCategory",
            component: DetailRewardCategory,
            meta: {
              title: "Reward Category Detail",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
        ],
      },
      {
        path: "/deliveryLabelsForSampleProducts",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "DeliveryLabelsForSampleProducts",
            component: DeliveryLabel,
            meta: {
              title: "Delivery Labels For Sample Products",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
        ],
      },
      {
        path: "/topSpenderCampaign",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "TopSpenderCampaign",
            component: TopSpenderCampaign,
            meta: {
              title: "Top Spender Campaign",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
          {
            path: "detailTopSpenderCampaign",
            name: "DetailTopSpenderCampaign",
            component: DetailTopSpenderCampaign,
            meta: {
              title: "Top Spender Campaign Detail",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
        ],
      },
      {
        path: "/referralCampaign",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "ReferralCampaign",
            component: ReferralCampaign,
            meta: {
              title: "Referral Campaign",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
          {
            path: "detailReferralCampaign",
            name: "DetailReferralCampaign",
            component: DetailReferralCampaign,
            meta: {
              title: "Referral Campaign Detail",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
        ],
      },
      {
        path: "/contactSubject",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "ContactSubjects",
            component: ContactSubjects,
            meta: {
              title: "Contact Subjects",
              requiresAuth: true,
              auth: ["ROLE_ADMIN"],
            },
          },
          {
            path: "detailcontactsubject",
            name: "DetailContactSubject",
            component: DetailContactSubjects,
            meta: {
              title: "Contact Subjects Detail",
              requiresAuth: true,
              auth: ["ROLE_ADMIN"],
            },
          },
        ],
      },
      {
        path: "/broadcastMessages",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "BroadcastMessages",
            component: BroadcastMessages,
            meta: {
              title: "Broadcast Messages",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
          {
            path: "detailBroadcastMessage",
            name: "DetailBroadcastMessage",
            component: DetailBroadcastMessages,
            meta: {
              title: "Broadcast Messages Detail",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
        ],
      },
      {
        path: "/broadcastMessageConfig",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "BroadcastMessageConfig",
            component: BroadcastMessageConfig,
            meta: {
              title: "Broadcast Messages Configuration",
              requiresAuth: true,
              auth: ["ROLE_ADMIN"],
            },
          },
        ],
      },
      {
        path: "/crmTriggers",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "CrmTriggers",
            component: CrmTrigger,
            meta: {
              title: "Crm Triggers",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
          {
            path: "detailCrmTrigger",
            name: "DetailCrmTrigger",
            component: DetailCrmTrigger,
            meta: {
              title: "Crm Triggers Detail",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
        ],
      },
      {
        path: "/shiseidoProductCategory",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "ShiseidoProductCategory",
            component: ShiseidoProductCategory,
            meta: {
              title: "Shiseido Product Category",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_SH_BRAND_ADMIN"],
            },
          },
        ],
      },
      {
        path: "/cpbProductFullDescription",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "CPBProductFullDescription",
            component: CPBProductFullDescription,
            meta: {
              title: "CPB Product Full Description",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_CPB_BRAND_ADMIN"],
            },
          },
        ],
      },
      {
        path: "/productMaster",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "ProductMaster",
            component: ProductMaster,
            meta: {
              title: "Product Master",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
          {
            path: "detailproductmaster",
            name: "DetailProductMaster",
            component: DetailProduct,
            meta: {
              title: "Product Master Detail",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
        ],
      },
      {
        path: "/importProductDisplayName",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "ImportProductDisplayName",
            component: ImportProductDisplayName,
            meta: {
              title: "Import Product Display Name",
              requiresAuth: true,
              auth: ["ROLE_ADMIN"],
            },
          },
        ],
      },
      {
        path: "/storeMaster",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "StoreMaster",
            component: StoreMaster,
            meta: {
              title: "Store Master",
              requiresAuth: true,
              auth: [
                "ROLE_ADMIN",
                "ROLE_BRAND_ADMIN",
                "ROLE_BC",
                "ROLE_SALES_SUPERVISOR",
              ],
            },
          },
          {
            path: "detailStore",
            name: "DetailStore",
            component: DetailStore,
            meta: {
              title: "Store Detail",
              requiresAuth: true,
              auth: [
                "ROLE_ADMIN",
                "ROLE_BRAND_ADMIN",
                "ROLE_BC",
                "ROLE_SALES_SUPERVISOR",
              ],
            },
          },
          {
            path: "counterService",
            name: "CounterService",
            component: CounterService,
            meta: {
              title: "Counter Service",
              requiresAuth: true,
              auth: [
                "ROLE_ADMIN",
                "ROLE_BRAND_ADMIN",
                "ROLE_SALES_SUPERVISOR",
                "ROLE_BC",
              ],
            },
          },
          {
            path: "detailResourceMaster",
            name: "DetailResourceMaster",
            component: DetailResourceMaster,
            meta: {
              title: "Resource Master Detail",
              requiresAuth: true,
              auth: [
                "ROLE_ADMIN",
                "ROLE_BRAND_ADMIN",
                "ROLE_SALES_SUPERVISOR",
                "ROLE_BC",
              ],
            },
          },
        ],
      },
      {
        path: "/serviceMaster",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "ServiceMaster",
            component: Service,
            meta: {
              title: "Service Master",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
          {
            path: "detailServiceMaster",
            name: "DetailServiceMaster",
            component: DetailServiceMaster,
            meta: {
              title: "Service Master Detail",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
        ],
      },
      {
        path: "/booking",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "Booking",
            component: Booking,
            meta: {
              title: "Booking",
              requiresAuth: true,
              auth: ["ROLE_SALES_SUPERVISOR", "ROLE_BC", "ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
          {
            path: "detailBooking",
            name: "DetailBooking",
            component: DetailBooking,
            meta: {
              title: "Booking Detail",
              requiresAuth: true,
              auth: ["ROLE_SALES_SUPERVISOR", "ROLE_BC", "ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
        ],
      },
      {
        path: "/bookingCalendar",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "BookingCalendar",
            component: BookingCalendar,
            meta: {
              title: "Booking Calendar",
              requiresAuth: true,
              auth: ["ROLE_SALES_SUPERVISOR", "ROLE_BC", "ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
        ],
      },
      {
        path: "/survey",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "Survey",
            component: Survey,
            meta: {
              title: "Survey",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
          {
            path: "detailSurvey",
            name: "DetailSurvey",
            component: DetailSurvey,
            meta: {
              title: "Survey Detail",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
        ],
      },
      {
        path: "/posCustomer",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "PosCustomer",
            component: PosCustomer,
            meta: {
              title: "POS Customer",
              requiresAuth: true,
              auth: [
                "ROLE_ADMIN",
                "ROLE_BC",
                "ROLE_BRAND_ADMIN",
                "ROLE_SALES_SUPERVISOR",
              ],
            },
          },
          {
            path: "detailPosCustomer",
            name: "DetailPosCustomer",
            component: DetailPosCustomer,
            meta: {
              title: "POS Customer Detail",
              requiresAuth: true,
              auth: [
                "ROLE_ADMIN",
                "ROLE_BC",
                "ROLE_BRAND_ADMIN",
                "ROLE_SALES_SUPERVISOR",
              ],
            },
          },
        ],
      },
      {
        path: "/customerProfile",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "ListCustomerProfiles",
            component: CustomerProfile,
            meta: {
              title: "Customer Profile",
              requiresAuth: true,
              auth: [
                "ROLE_ADMIN",
                "ROLE_BRAND_ADMIN",
                "ROLE_BC",
                "ROLE_SALES_SUPERVISOR",
              ],
            },
          },
          {
            path: "detailCustomerProfile",
            name: "DetailCustomerProfile",
            component: DetailCustomerProfile,
            meta: {
              title: "Customer Profile Detail",
              requiresAuth: true,
              auth: [
                "ROLE_ADMIN",
                "ROLE_BRAND_ADMIN",
                "ROLE_BC",
                "ROLE_SALES_SUPERVISOR",
              ],
            },
          },
        ],
      },
      {
        path: "/auditLogs",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "ListAuditLogs",
            component: AuditLogs,
            meta: {
              title: "Audit Logs",
              requiresAuth: true,
              auth: ["ROLE_ADMIN"],
            },
          },
        ],
      },
      {
        path: "/mobileAppSupportedVersions",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "MobileAppSupportedVersions",
            component: MobileAppSupportedVersion,
            meta: {
              title: "Mobile App Supported Version",
              requiresAuth: true,
              auth: ["ROLE_ADMIN"],
            },
          },
        ],
      },
      {
        path: "/reports",
        component: EmptyParentComponent,
        children: [
          {
            path: "CrmMetrics",
            component: EmptyParentComponent,
            children: [
              {
                path: "/",
                name: "CrmMetrics",
                component: CrmMetrics,
                meta: {
                  title: "Crm Metrics",
                  requiresAuth: true,
                  auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
                },
              },
              {
                path: "detailCrmMetrics",
                name: "DetailCrmMetrics",
                component: DetailCrmMetrics,
                meta: {
                  title: "Crm Metrics Detail",
                  requiresAuth: true,
                  auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
                },
              },
            ],
          },
          {
            path: "CustomerMetrics",
            component: EmptyParentComponent,
            children: [
              {
                path: "/",
                name: "CustomerMetrics",
                component: CustomerMetrics,
                meta: {
                  title: "Customer Metrics",
                  requiresAuth: true,
                  auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
                },
              },
              {
                path: "detailCustomerMetrics",
                name: "DetailCustomerMetrics",
                component: DetailCustomerMetrics,
                meta: {
                  title: "Customer Metrics Detail",
                  requiresAuth: true,
                  auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
                },
              },
            ],
          },
          {
            path: "Retention",
            name: "Retention",
            component: RetentionProduct,
            meta: {
              title: "Retention product",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
          {
            path: "CustomerList",
            name: "CustomerList",
            component: CustomerListByPurchasedProduct,
            meta: {
              title: "Customer list by purchased product",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
          {
            path: "Survey",
            name: "SurveyReport",
            component: SurveyReport,
            meta: {
              title: "Survey Report",
              requiresAuth: true,
              auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
            },
          },
          {
            path: "AgeGroup",
            component: EmptyParentComponent,
            children: [
              {
                path: "/",
                name: "AgeGroup",
                component: AgeGroup,
                meta: {
                  title: "Age Group",
                  requiresAuth: true,
                  auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
                },
              },
              {
                path: "detailAgeGroupReport",
                name: "DetailAgeGroupReport",
                component: DetailAgeGroupReport,
                meta: {
                  title: "Detail Age Group Report",
                  requiresAuth: true,
                  auth: ["ROLE_ADMIN", "ROLE_BRAND_ADMIN"],
                },
              },
            ],
          },
        ],
      },
      {
        path: "/publicHolidays",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "Public Holidays",
            component: PublicHolidays,
            meta: {
              title: "Public Holidays",
              requiresAuth: true,
              auth: ["ROLE_ADMIN"],
            },
          },
        ],
      },
      {
        path: "/shift",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "Shift",
            component: Shift,
            meta: {
              title: "Shift",
              requiresAuth: true,
              auth: ["ROLE_ADMIN","ROLE_BRAND_ADMIN", "ROLE_SALES_SUPERVISOR" ],
            },
          },
        ],
      },
      {
        path: "/officialWebsite/userRevocations",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "UserRevocations",
            component: UserRevocations,
            meta: {
              title: "Official Website User Revocations",
              requiresAuth: true,
              auth: ["ROLE_ADMIN"],
            },
          },
          {
            path: "detailUserRevocation",
            name: "UserRevocationDetail",
            component: UserRevocationDetail,
            meta: {
              title: "Official Website User Revocation Detail",
              requiresAuth: true,
              auth: ["ROLE_ADMIN"],
            },
          },
        ],
      },
      {
        path: "/officialWebsite",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "OfficialWebsiteUser",
            component: OfficialWebsite,
            meta: {
              title: "Official Website User",
              requiresAuth: true,
              auth: ["ROLE_ADMIN"],
            },
          },
        ],
      },
      {
        path: "/targetEmail",
        component: EmptyParentComponent,
        children: [
          {
            path: "/",
            name: "TargetEmail",
            component: TargetEmail,
            meta: {
              title: "Target Email",
              requiresAuth: true,
              auth: ["ROLE_ADMIN"],
            },
          },
        ],
      },
    ],
  },
  {
    path: "/",
    component: AppLogin,
    meta: {
      login: true,
    },
    children: [
      {
        path: "/login",
        name: "Login",
        component: Login,
      },
      {
        path: "/resetpass",
        name: "ResetPass",
        component: ResetPassword,
        meta: {
          title: "Reset Password"
        }
      },
    ],
  },
  {
    path: "/systemStatus",
    component: EmptyLayout,
    children: [
      {
        path: "/",
        name: "ListSystemStatus",
        component: SystemStatus,
        meta: {
          title: "System Status",
          requiresAuth: false,
        },
      },
    ],
  },
];

const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes,
});

function getNextRoute(config) {
  const {
    to,
    haveToken,
    isAdmin,
    next,
    isBrandAdmin,
    isBC,
    isSalesSupervisor,
    isPermitted,
  } = config;

  if (to.name === "Login" && haveToken && isAdmin) {
    next({ name: "Users" });
  }
  if (to.name === "Login" && haveToken && isBrandAdmin) {
    next({ name: "Brand" });
  }
  if (to.name === "Login" && haveToken && (isBC || isSalesSupervisor)) {
    next({ name: "ResetCustomerPass" });
  }
  if (isPermitted || !to.meta.auth) {
    next();
  } else {
    next({ name: "Exception401" });
  }
}

function getShiseidoBrandAdmin(userRole, roleBrandAdmin, userBrand) {
  return userRole?.includes(roleBrandAdmin) && userBrand?.includes("SH");
}

function getCpbBrandAdmin(userRole, roleBrandAdmin, userBrand) {
  return userRole?.includes(roleBrandAdmin) && userBrand?.includes("CP");
}

function isNotAuthenticated(to, haveToken) {
  return to.matched.some((record) => record.meta.requiresAuth) && !haveToken;
}

function isRoleAdmin(a, roleAdmin, isAdmin) {
  return a === roleAdmin && isAdmin;
}

function isRoleBC(a, roleBC, isBC) {
  return a === roleBC && isBC;
}

function isRoleSalesSuperVisor(a, roleSalesSupervisor, isSalesSupervisor) {
  return a === roleSalesSupervisor && isSalesSupervisor;
}

function isRoleBrandAdmin(a, roleBrandAdmin, isBrandAdmin) {
  return a === roleBrandAdmin && isBrandAdmin;
}

function isRoleSHBrandAdmin(a, roleSHBrandAdmin, isShiseidoBrandAdmin) {
  return a === roleSHBrandAdmin && isShiseidoBrandAdmin;
}

function isRoleCPBAdmin(a, roleCPBBrandAdmin, isCPBBrandAdmin) {
  return a === roleCPBBrandAdmin && isCPBBrandAdmin;
}

router.beforeEach(async (to, from, next) => {
  const haveToken = !!TokenService.getToken();

  const roleAdmin = "ROLE_ADMIN";
  const roleBrandAdmin = "ROLE_BRAND_ADMIN";
  const roleBC = "ROLE_BC";
  const roleSalesSuperVisor = "ROLE_SALES_SUPERVISOR";
  const roleSHBrandAdmin = "ROLE_SH_BRAND_ADMIN";
  const roleCPBBrandAdmin = "ROLE_CPB_BRAND_ADMIN";
  const userBrand = JSON.parse(TokenService.getUserBrands());
  const userRole = JSON.parse(TokenService.getUserRoles());
  const isAdmin = userRole?.includes(roleAdmin);
  const isBrandAdmin = userRole?.includes(roleBrandAdmin);
  const isBC = userRole?.includes(roleBC);
  const isSalesSupervisor = userRole?.includes(roleSalesSuperVisor);
  const isShiseidoBrandAdmin = getShiseidoBrandAdmin(
    userRole,
    roleBrandAdmin,
    userBrand
  );
  const isCPBBrandAdmin = getCpbBrandAdmin(userRole, roleBrandAdmin, userBrand);

  let isPermitted = false;
  if (isNotAuthenticated(to, haveToken)) {
    next({ name: "Login", query: { redirect: to.fullPath } });
    return;
  }
  to.meta.auth?.forEach((a) => {
    if (isRoleAdmin(a, roleAdmin, isAdmin)) {
      isPermitted = true;
    }
    if (isRoleBC(a, roleBC, isBC)) {
      isPermitted = true;
    }
    if (isRoleSalesSuperVisor(a, roleSalesSuperVisor, isSalesSupervisor)) {
      isPermitted = true;
    }
    if (isRoleBrandAdmin(a, roleBrandAdmin, isBrandAdmin)) {
      isPermitted = true;
    }
    if (isRoleSHBrandAdmin(a, roleSHBrandAdmin, isShiseidoBrandAdmin)) {
      isPermitted = true;
    }
    if (isRoleCPBAdmin(a, roleCPBBrandAdmin, isCPBBrandAdmin)) {
      isPermitted = true;
    }
  });
  getNextRoute({
    to,
    haveToken,
    isAdmin,
    next,
    isBrandAdmin,
    isBC,
    isSalesSupervisor,
    isPermitted,
  });
});

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};

const VueRouterReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch((err) => err);
};

export default router;
